/** Zelle payments – send money to this number */
export const ZELLE_PAYMENT_NUMBER = "215-571-5062";
export const ZELLE_PAYMENT_NUMBER_RAW = "2155715062";

/** General contact / concierge – call or text for questions */
export const CONTACT_PHONE = "215-316-9882";

/** Business email – all contact/form inquiries should reach this inbox */
export const BUSINESS_EMAIL = "lorlima83@gmail.com";

/** Official Facebook page URL – single source of truth used across footer, schema.org, and social links */
export const FACEBOOK_URL = "https://www.facebook.com/lorenascleaningservice101/";

export const BUSINESS_HOURS = [
  '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', 
  '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00'
];


export const SERVICES = [
  {
    id: 'standard',
    title: 'Standard Refresh',
    description: 'Essential weekly maintenance to keep your home breathing.',
    icon: 'zap',
    tag: 'Flexible Pricing'
  },
  {
    id: 'deep',
    title: 'Deep Clean',
    description: 'A complete restoration. We move furniture and scrub corners you didn\'t know existed.',
    icon: 'sparkles',
    tag: 'Most Popular',
    highlight: true
  },
  {
    id: 'commercial',
    title: 'Pro & Commercial',
    description: 'Industrial strength solutions for offices, estates, and post-construction.',
    icon: 'crown',
    tag: 'Custom Quote'
  }
];

/**
 * Max lengths for text fields (UI + validation). Keep in sync with `netlify/functions/_fieldLimits.js`.
 */
export const LORENA_MAX_LONG_TEXT = 8000;
export const LORENA_MAX_INQUIRY_MESSAGE = 8000;
export const LORENA_MAX_DISPLAY_NAME = 200;
export const LORENA_MAX_PHONE = 40;
export const LORENA_MAX_EMAIL = 320;
export const LORENA_MAX_ADDRESS = 2000;
export const LORENA_MAX_ACCESS_CODE = 500;
